import angularModule from 'Lessons/angularModule/scripts/lessons_module';
import 'ExtensionMethods/array';
import { FrameViewModel } from 'Lessons/FrameViewModel';

angularModule.factory('Lesson.FrameList.Frame.Componentized.ComponentizedBaseViewModel', [
    '$injector',

    $injector => {
        const ComponentModel = $injector.get('Lesson.FrameList.Frame.Componentized.Component.ComponentModel');

        class ComponentizedBaseViewModel extends FrameViewModel {
            constructor(frame, options) {
                super(frame, options);
                this.bodyBackgroundColor = 'white'; // can be set by a view model's initialize function
                this.continueButtonVisible = false;
                this._viewModels = {};

                this.callbacks = {
                    completed: [],
                    giveHint: [],
                };

                // initialize all viewModels
                this.frame.components.forEach(component => {
                    this.viewModelFor(component);
                });
            }

            get continueButtonViewModel() {
                const continueButton = this.frame.continueButton;
                if (!continueButton && !this.editorMode) {
                    throw new Error('No continue button found on frame');
                }
                if (continueButton) {
                    return this.viewModelFor(continueButton);
                }
                return undefined;
            }

            get complete() {
                throw new Error('Subclasses of ComponentizedBaseViewModel must implement complete');
            }

            // in order to handle some
            // logging in scope.$digest, angular was trying to toJson the
            // frameViewModel.  The circular reference in _viewModels was then throwing an error.
            // This removes _viewModels  from the enumerable properties, alowing it to
            // be toJsonned.
            get _viewModels() {
                return this.$$viewModels;
            }

            set _viewModels(val) {
                this.$$viewModels = val;
            }

            setBackgroundColor() {
                if (!this.editorMode) {
                    this.playerViewModel.setBodyBackground(this.bodyBackgroundColor);
                }
            }

            destroy() {
                super.destroy();
                this.$$_completedEventListener?.cancel();
            }

            viewModelFor(model) {
                return this.viewModelsFor([model])[0];
            }

            viewModelsFor(models) {
                const viewModels = [];
                angular.forEach(models, model => {
                    if (!model || !model.isA || !model.isA(ComponentModel)) {
                        // oxlint-disable-next-line no-console
                        console.error('Not a ComponentModel: ', model);
                        throw new Error(
                            `Cannot create ComponentViewModel for something which is not a ComponentModel: ${model}`,
                        );
                    }
                    if (model.frame() !== this.frame) {
                        const modelFrameId = model.frame() ? model.frame().id : 'undefined';
                        throw new Error(
                            `Cannot create viewModel for component that is unrelated to this frame. model.frame() = ${modelFrameId}, model.id = ${model.id}`,
                        );
                    }

                    // if we don't have a viewModel yet, and this component supports ViewModels, create one
                    if (!this._viewModels[model.id] && model.constructor.ViewModel) {
                        this._viewModels[model.id] = model.createViewModel(this);
                    }
                    viewModels.push(this._viewModels[model.id]);
                });
                return viewModels;
            }

            gotoNextFrame() {
                const nextFrameId = this.viewModelFor(this.frame.frameNavigator).nextFrameId;
                if (!this.editorMode && this.playerViewModel.logProgress) {
                    const historyLen = this.playerViewModel.frameHistory.length;
                    if (this.playerViewModel.frameHistory[historyLen - 1] !== this.frame.id) {
                        this.playerViewModel.frameHistory.push(this.frame.id);
                    }
                }
                if (nextFrameId) {
                    this.playerViewModel.gotoFrameId(nextFrameId);
                } else {
                    this.playerViewModel.gotoNext();
                }
            }
        }

        return ComponentizedBaseViewModel;
    },
]);
